// Core Imports
import GraniteError from 'granite-admin/utils/granite-error';
import GraniteAPIClient from 'granite-admin/utils/granite-client';
import TaskMasterEntity from 'granite-admin/common/entities/taskMaster';
import TaskEntity from 'granite-admin/common/entities/task';
import { env } from 'granite-admin/env';
const url = env.REACT_APP_GRANITE_BASE_URL || process.env.REACT_APP_GRANITE_BASE_URL;
async function getTasksList(params) {
  const payload = {
    params: {
      ...params
    }
  };
  try {
    const {
      data
    } = await GraniteAPIClient(url).get('/task-masters/', payload);
    const list = data.results.map(item => new TaskMasterEntity(item));
    return {
      list,
      count: data.count,
      nextPage: data.next_page
    };
  } catch (error) {
    throw new GraniteError(error);
  }
}
async function getTaskDetails({
  id
}) {
  try {
    const {
      data
    } = await GraniteAPIClient(url).get(`/task-masters/${id}/`);
    return new TaskMasterEntity(data);
  } catch (error) {
    throw new GraniteError(error);
  }
}
async function postTask(params) {
  const payload = {
    params: {
      ...params
    }
  };
  try {
    if (payload.params.pk) {
      //edit
      const {
        data
      } = await GraniteAPIClient(url).put(`/task-masters/${payload.params.pk}/`, payload.params);
      return data;
    } else {
      //create
      const {
        data
      } = await GraniteAPIClient(url).post('/task-masters/', payload.params);
      return data;
    }
  } catch (error) {
    throw new GraniteError(error);
  }
}
async function deleteTasks(list) {
  try {
    return await GraniteAPIClient(url).delete(`/task-masters/`, {
      data: {
        pks: list
      }
    });
  } catch (error) {
    throw new GraniteError(error);
  }
}
async function getEntityTasks(params) {
  const payload = {
    params: {
      ...params
    }
  };
  try {
    const {
      data
    } = await GraniteAPIClient(url).get('/tasks/', payload);
    const list = data.results.map(item => new TaskEntity(item));
    return {
      list,
      count: data.count,
      nextPage: data.next_page
    };
  } catch (error) {
    throw new GraniteError(error.errors);
  }
}
async function closeTask(pk) {
  try {
    return await GraniteAPIClient(url).post(`/tasks/${pk}/close/`);
  } catch (error) {
    throw new GraniteError(error.errors);
  }
}
export default {
  getTasksList,
  getTaskDetails,
  postTask,
  deleteTasks,
  getEntityTasks,
  closeTask
};